import { startGetPerson } from "../../actions/people";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

function Greeting() {
  const dispatch = useDispatch();
  const firstName = useSelector((state) => state.person.name);
  const lastName = useSelector((state) => state.person.lastName);
  const fullName = `${firstName} ${lastName}`;

  useEffect(() => {
    //dispatch(startGetPerson());
  }, [firstName, lastName]);
  return (
    <h1 className="section-title-inner heading-sm strong-600 text-uppercase">
      <span>Hola {fullName}</span>
    </h1>
  );
}

export default Greeting;
